if (!window.active_cfg) {
    throw '配置文件不存在';
}

var login_config = {
    cookie_list: 'vip_nickname vip_usrname vip_growvalue vip_expiredate vip_level vip_isyear vip_paytype vip_isvip vip_daily vip_payname vip_is_good_number vip_num_is_open_vip vip_num_due_time vip_safebox vip_autopay act_cmb vas_type jsq_isvip jsq_expiredate ischild history vip_expiredays vip_kn_isvip vip_kn_level vip_kn_expiredate jsq_growvalue jsq_expiredate jsq_level jsq_paytype jsq_type jsq_score jsq_expiretype jsq_trialvip jsq_trialexpire'.split(' '),
    cookie_list_val: 'nickname usrname growvalue expiredate level isyear paytype isvip daily payname is_good_number num_is_open_vip num_due_time safebox autopay act_cmb vas_type jsq_isvip jsq_expiredate ischild history expiredays kn_isvip kn_level kn_expiredate jsq_growvalue jsq_expiredate jsq_level jsq_paytype jsqtype jsq_score jsq_expiretype jsq_trialvip jsq_trialexpire'.split(' ')
};

var $ = require('jquery');
$.live = function(selects, fn) {
    return $(document).on('click', selects, fn);
}

$.jsonp = function(url, data, callback) {
    if (typeof data === 'function') {
        callback = data;
        data = '';
    }

    var _callback = function(rs) {
        if (rs.result === -100) {
            clearCookie();
            logout();
            login();
        } else {
            callback(rs);
        }
    }

    return $.ajax({
        url: url,
        data: data,
        dataType: 'jsonp',
        success: _callback
    });
}

window.ajax = function(action, data, success, error) {
    if (!haslogin()) {
        login();
        return;
    }
    var url = 'http://dyactive2.vip.xunlei.com';
    if (typeof action !== 'string') {
        throw 'error action';
    }
    if (typeof data === 'function') {
        error = success;
        success = data;
        data = {};
    } else {
        data = data || {};
    }

    data.action = action;
    data.actid = active_cfg.base.actid;

    return $.ajax({
        url: 'http://dyactive2.vip.xunlei.com/iface/',
        dataType: 'jsonp',
        data: data,
        success: function(r) {
            if (r.result === -100) {
                clearCookie();
                logout();
                login();
            } else {
                success && success.call(this, r);
            }
        },
        error: error
    });
}

$.left = function(leftTime) {

    function checkTime(i) {
        if (i < 10) {
            i = "0" + i;
        } else {
            i = "" + i;
        }
        return i;
    }
    var days = parseInt(leftTime / 60 / 60 / 24, 10);
    var hours = parseInt(leftTime / 60 / 60 % 24, 10);
    var minutes = parseInt(leftTime / 60 % 60, 10);
    var seconds = parseInt(leftTime % 60, 10);
    days = checkTime(days);
    hours = checkTime(hours);
    minutes = checkTime(minutes);
    seconds = checkTime(seconds);
    return {
        d: days,
        h: hours,
        m: minutes,
        s: seconds
    }
}

var util = require('./util.js');
var login = require('./login.js');
var user = require('./user.js');
var msgbox = require('./msgbox.js');
var renew = require('../renew/renew2.js');
var head = require('./head');
require('./foot.js');
var actid = active_cfg.base.actid;
document.title = active_cfg.base.actname;
document.domain = 'xunlei.com';
var referfrom = util.getSearch('referfrom');

if (referfrom) {
    setRealCookie('referfrom', referfrom, undefined, 1);
}

function start() {
    if (location.host === 'vip.xunlei.com') {
        addNavAni();
    }
    bindEvents();
    init();
    if (login.haslogin()) {
        loginInit();
    } else {
        loginInit.fail && loginInit.fail();
    }
}

function addNavAni() {
    //导航动画
    function navGif(height, times, speed) {
        var _position = 0,
            _height = height * times * (-1),
            _interval;

        _interval = setInterval(function() {
            if (_position >= _height) {
                $(".vip-header .gif").css("background-position", "center " + _position + "px");
                _position -= speed;
            } else {
                $(".vip-header .gif").css("background", "none");
                clearInterval(_interval);
            }
        }, 100);
    }

    $(document).ready(function() {
        navGif(186, 3, 10);
    })
}

function setPageNav(index) {
    //页面导航
    if (index) {
        $('ul.menu li[index="' + index + '"]').addClass('cur');
    }
}

var autoAdaption = {
    run: function(){
        autoAdaption.adaption();
        $(window).resize(autoAdaption.adaption);
    },
    adaption: function () {
        //页面自适应
        var pw = $(window).width();
        if (pw <= 1000) {
            $("html").removeClass().addClass("w900");
        } else if (pw <= 1100) {
            $("html").removeClass().addClass("w1000");
        } else if (pw <= 1200) {
            $("html").removeClass().addClass("w1100");
        } else if (pw <= 1300) {
            $("html").removeClass().addClass("w1300");
        } else if (pw <= 1400) {
            $("html").removeClass().addClass("w1400");
        } else {
            $("html").removeClass();
        }
    }
};

function bindEvents() {
    $('#hd_index').on('mouseenter', '.vip-usertop', function() {
        $('#header-login .p_selfcon').show();
    }).on('mouseleave', '.vip-usertop', function() {
        $('#header-login .p_selfcon').hide();
    }).on('click', '[name="logout"]', function() {
        login.logout();
        return false;
    }).on('click', '[name="login"]', function() {
        login.login();
        return false;
    });

    //导航hover出二级菜单
    $(".vip-header .menu li").hover(function() {
        var subnav_ind = $(this).index();
        $(".subnav_wp").show();
        $(".subnav_wp .menu").hide();
        $(".subnav_wp").find(".subnav_" + subnav_ind).show();
    }, function() {
        $(".subnav_wp").hide();
    });
    $(".subnav_wp").hover(function() {
        $(this).show();
    }, function() {
        $(this).hide();
        $(".subnav_wp .menu").hide();;
    });
}

function init() {

    $.ajax({
        url: 'http://dyactive2.vip.xunlei.com/iface/?action=init&actid=' + actid,
        dataType: 'jsonp',
        success: function(r) {
            if (r.result == 0) {
                var data = r.data;
                r.data.message && msgbox.showErrorMsg(r.data.message);
                init.cb && init.cb(data);
            }
        }
    })
}

function onInit(fn) {
    init.cb = fn;
}

function loginInit() {
    var param = {
        userInfo: 1
    };

    if(location.host == 'act.jsq.xunlei.com'){
        param['jsqInfo'] = 1;
    }

    return $.ajax({
        url: 'http://dyactive2.vip.xunlei.com/iface/?action=logininit&actid=' + actid,
        dataType: 'jsonp',
        data: param,
        success: function(r) {
            if (r.result == 0) {
                var data = r.data;
                setUserInfo(data.userInfo);
                if (location.host === 'vip.xunlei.com') {
                    renew();
                }
                r.data.message && msgbox.showErrorMsg(r.data.message);
                loginInit.cb && loginInit.cb(data);
            } else if (r.result === -100) {
                clearCookie();
                loginInit.fail && loginInit.fail();
            }
        }
    })
}

function onLoginInit(fn, fn2) {
    loginInit.cb = fn;
    loginInit.fail = fn2;
}

var userInfo = {};

function setUserInfo(data) {
    if (data) {
        userInfo = data;

        var regcookie = function(cname, name) {
            if (data[name] != undefined) {
                //console.log('setCookie '+ cname + '  ' + data[name] + '  '+ name);
                setCookie(cname, data[name]);
            }


        };
        var cookie_list = login_config.cookie_list;
        var cookie_list_val = login_config.cookie_list_val;
        for (var i = 0, len = cookie_list.length; i < len; i++) {
            regcookie(cookie_list[i], cookie_list_val[i]);
        }
        head.init()
        //initHeader();
    }
}

window.loginInit = loginInit;
module.exports = {
    start: start,
    init: init,
    setPageNav: setPageNav,
    autoAdaption: autoAdaption.run,
    loginInit: loginInit,
    onInit: onInit,
    onLoginInit: onLoginInit
}



//////////////////
// WEBPACK FOOTER
// ./src/common/main.js
// module id = 8
// module chunks = 2